var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Video",
    clipPath: "url(#clip0_1940_1997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3333 17.5V11.6667C28.3333 10.75 27.5833 10 26.6667 10H6.66667C5.75 10 5 10.75 5 11.6667V28.3333C5 29.25 5.75 30 6.66667 30H26.6667C27.5833 30 28.3333 29.25 28.3333 28.3333V22.5L35 29.1667V10.8333L28.3333 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_1997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMedia);
export default __webpack_public_path__ + "static/media/White-Media.876e2a127e93d756b0f68d0932406afc.svg";
export { ForwardRef as ReactComponent };